import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * RepresentativeExceptionsApi - axios parameter creator
 * @export
 */
const RepresentativeExceptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (bookingTypeId, options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {String} [startDate]
         * @param {String} [endDate]
         * @param {number} [representativeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByDateRange: async (bookingTypeId, startDate, endDate, representativeId, options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/GetByDateRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString() :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString() :
                    endDate;
            }
            if (representativeId !== undefined) {
                localVarQueryParameter['representativeId'] = representativeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [representativeId]
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByRepresentative: async (representativeId, bookingTypeId, options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/GetByRepresentative`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (representativeId !== undefined) {
                localVarQueryParameter['representativeId'] = representativeId;
            }
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExceptionTypes: async (options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/GetExceptionTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepresentativesForBookingType: async (bookingTypeId, options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/GetRepresentativesForBookingType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeModes: async (options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/GetTimeModes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (RepresentativeExceptionToken, cancelAffected, options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (cancelAffected !== undefined) {
                localVarQueryParameter['cancelAffected'] = cancelAffected;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RepresentativeExceptionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
         * @param {number} [id]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (RepresentativeExceptionToken, id, cancelAffected, options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (cancelAffected !== undefined) {
                localVarQueryParameter['cancelAffected'] = cancelAffected;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RepresentativeExceptionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateRepresentativeExceptionConflicts: async (RepresentativeExceptionToken, options = {}) => {
            const localVarPath = `/v1/RepresentativeExceptions/ValidateRepresentativeExceptionConflicts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RepresentativeExceptionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RepresentativeExceptionsApi - functional programming interface
 * @export
 */
const RepresentativeExceptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = RepresentativeExceptionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(bookingTypeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(bookingTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {String} [startDate]
         * @param {String} [endDate]
         * @param {number} [representativeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByDateRange(bookingTypeId, startDate, endDate, representativeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByDateRange(bookingTypeId, startDate, endDate, representativeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.getByDateRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [representativeId]
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByRepresentative(representativeId, bookingTypeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByRepresentative(representativeId, bookingTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.getByRepresentative']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExceptionTypes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExceptionTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.getExceptionTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepresentativesForBookingType(bookingTypeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepresentativesForBookingType(bookingTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.getRepresentativesForBookingType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeModes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeModes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.getTimeModes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(RepresentativeExceptionToken, cancelAffected, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(RepresentativeExceptionToken, cancelAffected, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
         * @param {number} [id]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(RepresentativeExceptionToken, id, cancelAffected, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(RepresentativeExceptionToken, id, cancelAffected, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateRepresentativeExceptionConflicts(RepresentativeExceptionToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateRepresentativeExceptionConflicts(RepresentativeExceptionToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepresentativeExceptionsApi.validateRepresentativeExceptionConflicts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * RepresentativeExceptionsApi - factory interface
 * @export
 */
const RepresentativeExceptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RepresentativeExceptionsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(bookingTypeId, options) {
            return localVarFp.getAll(bookingTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {String} [startDate]
         * @param {String} [endDate]
         * @param {number} [representativeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByDateRange(bookingTypeId, startDate, endDate, representativeId, options) {
            return localVarFp.getByDateRange(bookingTypeId, startDate, endDate, representativeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [representativeId]
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByRepresentative(representativeId, bookingTypeId, options) {
            return localVarFp.getByRepresentative(representativeId, bookingTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExceptionTypes(options) {
            return localVarFp.getExceptionTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepresentativesForBookingType(bookingTypeId, options) {
            return localVarFp.getRepresentativesForBookingType(bookingTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeModes(options) {
            return localVarFp.getTimeModes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(RepresentativeExceptionToken, cancelAffected, options) {
            return localVarFp.insert(RepresentativeExceptionToken, cancelAffected, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
         * @param {number} [id]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(RepresentativeExceptionToken, id, cancelAffected, options) {
            return localVarFp.update(RepresentativeExceptionToken, id, cancelAffected, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateRepresentativeExceptionConflicts(RepresentativeExceptionToken, options) {
            return localVarFp.validateRepresentativeExceptionConflicts(RepresentativeExceptionToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RepresentativeExceptionsApi - object-oriented interface
 * @export
 * @class RepresentativeExceptionsApi
 * @extends {BaseAPI}
 */
class RepresentativeExceptionsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [bookingTypeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    getAll(bookingTypeId, options) {
        return RepresentativeExceptionsApiFp(this.configuration).getAll(bookingTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [bookingTypeId]
     * @param {String} [startDate]
     * @param {String} [endDate]
     * @param {number} [representativeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    getByDateRange(bookingTypeId, startDate, endDate, representativeId, options) {
        return RepresentativeExceptionsApiFp(this.configuration).getByDateRange(bookingTypeId, startDate, endDate, representativeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    getById(id, options) {
        return RepresentativeExceptionsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [representativeId]
     * @param {number} [bookingTypeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    getByRepresentative(representativeId, bookingTypeId, options) {
        return RepresentativeExceptionsApiFp(this.configuration).getByRepresentative(representativeId, bookingTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    getExceptionTypes(options) {
        return RepresentativeExceptionsApiFp(this.configuration).getExceptionTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [bookingTypeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    getRepresentativesForBookingType(bookingTypeId, options) {
        return RepresentativeExceptionsApiFp(this.configuration).getRepresentativesForBookingType(bookingTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    getTimeModes(options) {
        return RepresentativeExceptionsApiFp(this.configuration).getTimeModes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
     * @param {boolean} [cancelAffected]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    insert(RepresentativeExceptionToken, cancelAffected, options) {
        return RepresentativeExceptionsApiFp(this.configuration).insert(RepresentativeExceptionToken, cancelAffected, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    remove(id, options) {
        return RepresentativeExceptionsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
     * @param {number} [id]
     * @param {boolean} [cancelAffected]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    update(RepresentativeExceptionToken, id, cancelAffected, options) {
        return RepresentativeExceptionsApiFp(this.configuration).update(RepresentativeExceptionToken, id, cancelAffected, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {RepresentativeExceptionToken} [RepresentativeExceptionToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepresentativeExceptionsApi
     */
    validateRepresentativeExceptionConflicts(RepresentativeExceptionToken, options) {
        return RepresentativeExceptionsApiFp(this.configuration).validateRepresentativeExceptionConflicts(RepresentativeExceptionToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { RepresentativeExceptionsApi, RepresentativeExceptionsApiAxiosParamCreator, RepresentativeExceptionsApiFactory, RepresentativeExceptionsApiFp };
//# sourceMappingURL=representative-exceptions-api.js.map
